export const REFUND_REQUESTS_QUERY_KEYS = {
  all: ["refund-requests"] as const,

  lists: () => [...REFUND_REQUESTS_QUERY_KEYS.all, "list"] as const,
  infinite: (queryString: string, sortParams: string[]) =>
    [...REFUND_REQUESTS_QUERY_KEYS.lists(), "infinite", queryString || "all", JSON.stringify(sortParams)] as const,
  statusQueue: (statusName: string | null) =>
    [...REFUND_REQUESTS_QUERY_KEYS.lists(), "status-queue", statusName ?? "none"] as const,

  details: () => [...REFUND_REQUESTS_QUERY_KEYS.all, "detail"] as const,
  detail: (id: string) => [...REFUND_REQUESTS_QUERY_KEYS.details(), id] as const,

  statuses: (scope?: "used", currentStatusId?: number, refundRequestId?: string) => [...REFUND_REQUESTS_QUERY_KEYS.all, "statuses", scope ?? "all", currentStatusId ?? "none", refundRequestId ?? "none"] as const,
  families: (activeOnly = false) =>
    [...REFUND_REQUESTS_QUERY_KEYS.all, "families", activeOnly ? "active" : "all"] as const,
  references: (familyId?: string, activeOnly = false) =>
    familyId
      ? ([...REFUND_REQUESTS_QUERY_KEYS.all, "references", familyId, activeOnly ? "active" : "all"] as const)
      : ([...REFUND_REQUESTS_QUERY_KEYS.all, "references"] as const),

  subsidyEvaluation: (requestId: string) =>
    [...REFUND_REQUESTS_QUERY_KEYS.all, "subsidy-evaluation", requestId] as const,

  subLimGlobales: () => [...REFUND_REQUESTS_QUERY_KEYS.all, "sub-lim-globales"] as const,

  ledgerEntries: (requestId: string) =>
    [...REFUND_REQUESTS_QUERY_KEYS.all, "ledger-entries", requestId] as const,

  policyTree: () => [...REFUND_REQUESTS_QUERY_KEYS.all, "policy-tree"] as const,

  reattributionTargets: (ledgerEntryId: string, referenceDate: string) =>
    [...REFUND_REQUESTS_QUERY_KEYS.all, "reattribution-targets", ledgerEntryId, referenceDate] as const,

  reattributionPreview: (ledgerEntryId: string, targetRuleId: string, referenceDate: string) =>
    [...REFUND_REQUESTS_QUERY_KEYS.all, "reattribution-preview", ledgerEntryId, targetRuleId, referenceDate] as const,

  accountingLines: (requestId: string, includeSettled: boolean) =>
    [...REFUND_REQUESTS_QUERY_KEYS.all, "accounting-lines", requestId, includeSettled] as const,

  history: (requestId: string) =>
    [...REFUND_REQUESTS_QUERY_KEYS.all, "history", requestId] as const,
} as const;
